import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Sun, Moon, Languages, ChevronDown, UserRound } from "lucide-react";
import { useApp } from "../context/AppContext";
import { useAuth } from "../context/AuthContext";
import ExploreMenu from "./ExploreMenu";
import { EXPLORE_GROUPS, KIND_LABEL } from "../explore";

const LINKS = [
  { to: "/", key: "nav.home", id: "home" },
  { to: "/map", key: "nav.map", id: "map" },
  { to: "/knowledge", key: "nav.search", id: "knowledge" },
  { to: "/souq", key: "nav.souq", id: "souq" },
  { to: "/provenance", key: "nav.provenance", id: "provenance" },
];

export default function Navbar() {
  const { lang, theme, t, toggleLang, toggleTheme } = useApp();
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [exploreOpen, setExploreOpen] = useState(false);
  const { pathname } = useLocation();
  const close = () => setOpen(false);

  return (
    <nav className="lux-nav" data-testid="main-navbar">
      <div className="lux-nav-inner">
        <Link to="/" className="lux-logo" data-testid="nav-logo" onClick={close}>
          <span className="logo-ar">واحة التمور</span>
          <span className="logo-en">Dates Oasis</span>
        </Link>

        <div className="nav-links">
          <Link to="/" className={`nav-link ${pathname === "/" ? "active" : ""}`} data-testid="nav-link-home">
            {t("nav.home")}
          </Link>
          <ExploreMenu />
          {LINKS.slice(1).map((l) => (
            <Link
              key={l.id}
              to={l.to}
              className={`nav-link ${pathname === l.to ? "active" : ""}`}
              data-testid={`nav-link-${l.id}`}
            >
              {t(l.key)}
            </Link>
          ))}
        </div>

        <div className="nav-controls">
          <Link to={user ? "/dashboard" : "/auth"} className="icon-btn nav-account-btn" data-testid="nav-account-link" aria-label="Account" onClick={close}>
            <UserRound size={17} />
            <span className="nav-account-label">{user ? t("hub.kicker") : t("auth.tab_login")}</span>
          </Link>
          <button className="icon-btn lang-btn" onClick={toggleLang} data-testid="lang-toggle-button" aria-label="Toggle language">
            <Languages size={16} />
            <span>{lang === "ar" ? "EN" : "عربي"}</span>
          </button>
          <button className="icon-btn" onClick={toggleTheme} data-testid="theme-toggle-button" aria-label="Toggle theme">
            {theme === "dark" ? <Sun size={17} /> : <Moon size={17} />}
          </button>
          <button className="icon-btn menu-btn" onClick={() => setOpen((o) => !o)} data-testid="mobile-menu-button" aria-label="Menu">
            {open ? <X size={19} /> : <Menu size={19} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="mobile-menu" data-testid="mobile-menu-panel">
          <Link to="/" className={`mobile-link ${pathname === "/" ? "active" : ""}`} data-testid="mobile-link-home" onClick={close}>
            {t("nav.home")}
          </Link>
          <button
            className={`mobile-link mobile-accordion ${exploreOpen ? "open" : ""}`}
            onClick={() => setExploreOpen((o) => !o)}
            data-testid="mobile-explore-toggle"
            aria-expanded={exploreOpen}
          >
            {t("nav.explore")}
            <ChevronDown size={16} className="explore-chevron" />
          </button>
          {exploreOpen && (
            <div className="mobile-explore" data-testid="mobile-explore-panel">
              {EXPLORE_GROUPS.map((g) => (
                <div key={g.id} className="mobile-explore-group">
                  <Link to={g.to} className="mobile-explore-title" onClick={close} data-testid={`mobile-explore-group-${g.id}`}>
                    {g.label[lang]}
                  </Link>
                  {g.items.map((it) => (
                    <Link key={it.slug} to={it.to} className="mobile-explore-item" onClick={close} data-testid={`mobile-explore-item-${it.slug}`}>
                      {it.label[lang]}
                    </Link>
                  ))}
                </div>
              ))}
              <Link to="/stories" className="mobile-explore-title" onClick={close} data-testid="mobile-explore-stories">
                {KIND_LABEL.stories[lang]}
              </Link>
              <Link to="/gallery" className="mobile-explore-title" onClick={close} data-testid="mobile-explore-gallery">
                {KIND_LABEL.gallery[lang]}
              </Link>
            </div>
          )}
          {LINKS.slice(1).map((l) => (
            <Link
              key={l.id}
              to={l.to}
              className={`mobile-link ${pathname === l.to ? "active" : ""}`}
              data-testid={`mobile-link-${l.id}`}
              onClick={close}
            >
              {t(l.key)}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}
